import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';
import { IInputField } from '../../common/types/uiTypes';

const TextInputField = ({
  heading,
  placeholder,
  value,
  onChange,
  ariaLabel,
  type,
}: IInputField) => {
  return (
    <div className='dm-search-input ds-input'>
      {heading && <h2 className='custom-field-heading'>{heading}</h2>}
      <InputGroup>
        <Form.Control
          placeholder={placeholder}
          aria-label={ariaLabel}
          aria-describedby='text-input-field'
          value={value}
          onChange={onChange}
          type={type}
        />
      </InputGroup>
    </div>
  );
};

export default TextInputField;
